// Ждем загрузки приложения
setTimeout(() => {
    // Регистрируем обработчик для меню игроков
    window.playersmenu = (playersData) => {
        // Закрываем предыдущее окно если открыто
        if (window.currentPlayersMenu) {
            window.currentPlayersMenu.$destroy();
            window.currentPlayersMenu = null;
        }
        
        // Создаем новый экземпляр меню
        const target = document.createElement('div');
        document.body.appendChild(target);
        
        import('../views/admin/playersmenu/index.svelte').then(module => {
            window.currentPlayersMenu = new module.default({
                target: target,
                props: {}
            });
            
            // Передаем данные в меню
            try {
                const data = JSON.parse(playersData);
                if (window.currentPlayersMenu.setPlayersData) {
                    window.currentPlayersMenu.setPlayersData(data);
                }
            } catch(e) {
                console.error('Error parsing players data:', e);
            }
        }).catch(err => {
            console.error('Error loading players menu:', err);
        });
    };
    
    // Закрытие меню
    window.closePlayersMenu = () => {
        if (window.currentPlayersMenu) {
            window.currentPlayersMenu.$destroy();
            window.currentPlayersMenu = null;
        }
    };
}, 1000);